import { NyuLineProperties } from '../../../../shared/types'
import { Shape as ShapeComponent } from '../Shapes'
import { hatchColorOf, HatchSwatch } from './HatchPattern'
import ShapeRenderer from './HighContrastMode/Shape'
import { lineTypes } from '../../utils/options'

function ShapePatch(props: NyuLineProperties) {
    const padding = props.barShapeStrokeWidth ?? 0 / 2
    const size = 100
    const viewbox = `${-padding} ${-padding} ${size + padding * 2} ${size + padding * 2}`
    return (
        <svg width={13} height={13} viewBox={viewbox}>
            <ShapeComponent {...props} />
        </svg>
    )
}

// Component that shows line style with optional shape for high contrast mode
function LineStyleIndicator({
    lineData,
    showShape,
    shapeType,
}: {
    lineData: NyuLineProperties
    showShape: boolean
    shapeType?: string
}) {
    const { color, linetype } = lineData
    const strokeDasharray = lineTypes[linetype || 'solid']

    if (showShape) {
        return (
            <svg width={24} height={12} className="shrink-0">
                <line
                    x1={2}
                    y1={6}
                    x2={22}
                    y2={6}
                    stroke={color}
                    strokeWidth={2}
                    strokeDasharray={strokeDasharray}
                />
                <ShapeRenderer
                    cx={12}
                    cy={6}
                    stroke={color!}
                    shape={
                        (shapeType && shapeType !== 'line'
                            ? shapeType
                            : 'circle') as any
                    }
                    size={5}
                />
            </svg>
        )
    }

    return <div className="size-3" style={{ background: color! }} />
}

export default function DataKeyLabel({
    lineData,
    highContrastMode = false,
    shapeType,
    letterIdentifier,
    isBarChart = false,
}: {
    lineData: NyuLineProperties
    highContrastMode?: boolean
    shapeType?: string
    letterIdentifier?: string
    isBarChart?: boolean
}) {
    const { label } = lineData
    const { key, ...lineDataRest } = lineData

    // a forecast series listed in its own right carries the hatching of its bars
    const hatchColor = isBarChart ? hatchColorOf(lineData) : undefined

    return (
        <span>
            <span className="mr-2 inline-flex w-3 justify-center">
                {lineData.barShapeType ? (
                    <div className="size-3">
                        <ShapePatch key={key} {...lineDataRest} />
                    </div>
                ) : hatchColor ? (
                    <HatchSwatch color={hatchColor} />
                ) : (
                    <LineStyleIndicator
                        lineData={lineData}
                        showShape={highContrastMode && !isBarChart}
                        shapeType={shapeType}
                    />
                )}
            </span>
            {letterIdentifier && (
                <span className="mr-1 text-sm font-bold">
                    {letterIdentifier}:
                </span>
            )}
            {label!}
        </span>
    )
}
